import { TranslationObject } from '../../i18n/translation';

const namespace = 'agreementtabs';

const translations: TranslationObject = {
  navnHeader: {
    id: `${namespace}.navnHeader`,
    nb: 'Avtalenavn',
    en: 'Agreement title',
  },
  ansvarligHeader: {
    id: `${namespace}.ansvarligHeader`,
    nb: 'Ansvarlig',
    en: 'Contact person',
  },
  parterHeader: {
    id: `${namespace}.parterHeader`,
    nb: 'Samarbeidsparter',
    en: 'No. agreement places',
  },
  statusHeader: {
    id: `${namespace}.statusHeader`,
    nb: 'Status',
    en: 'Status',
  },
  utloepsdatoHeader: {
    id: `${namespace}.utloepsdatoHeader`,
    nb: 'Utløpsdato',
    en: 'Expiration date',
  },
  statusAktiv: {
    id: `${namespace}.statusSignert`,
    nb: 'Aktiv',
    en: 'Active',
  },
  statusIkkeSignert: {
    id: `${namespace}.statusIkkeSignert`,
    nb: 'Sendt til signering',
    en: 'Awaiting signature',
  },
  statusKansellert: {
    id: `${namespace}.statusKansellert`,
    nb: 'Kansellert',
    en: 'Canceled',
  },
  statusInnhenterOpplysninger: {
    id: `${namespace}.statusInnhenterOpplysninger`,
    nb: 'Innhenter opplysninger',
    en: 'Gathering information',
  },
  statusAvsluttet: {
    id: `${namespace}.statusAvsluttet`,
    nb: 'Avsluttet',
    en: 'Concluded',
  },
  statusUtkast: {
    id: `${namespace}.statusUtkast`,
    nb: 'Utkast',
    en: 'Draft',
  },
  statusFeil: {
    id: `${namespace}.statusFeil`,
    nb: 'Feil',
    en: 'Failed',
  },
  statusInaktiv: {
    id: `${namespace}.statusInaktiv`,
    nb: 'Inaktiv',
    en: 'Inactive',
  },
  handlingHeader: {
    id: `${namespace}.handlingHeader`,
    nb: 'Handling',
    en: 'Action',
  },
  btnHandling: {
    id: `${namespace}.btnHandling`,
    nb: 'Vis avtale',
    en: 'Show agreement',
  },
  ingen: {
    id: `${namespace}.ingen`,
    nb: 'Ingen',
    en: 'None',
  },
};

export default translations;
